<template>
  <el-dialog title='新增' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='400px'>
    <el-form :model='form' label-width='130px' label-position='right' :rules='rules'
             ref='ruleForm' class='settlement-form mt20'>
      <el-form-item label='油价联动比率：' prop='ratio'>
        <el-input style='margin-top: 6px;' type='number' placeholder='请输入油价联动比率'
                  v-model='form.ratio' size='mini'>
          <template slot='append'>%</template>
        </el-input>
      </el-form-item>

      <p style='color:red;text-align: center;'>*注意：油价联动金额=单台运价*油价联动比率</p>

      <div class='flex-center-center mt20 mb20 pb20'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>确认
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { addOilPriceLinkage } from '@/service/getData';

  export default {
    name: 'addOilPriceLinkageForm',
    data() {
      return {
        dialogVisible: false,
        defaultForm: {},
        form: {
          ratio: '',
          freightInfoList: [],
        },
        rules: {
          ratio: [
            {
              required: true,
              message: '请输入油价联动比率',
              trigger: 'blur',
            },
          ],
        },
        submitLoading: false,
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      dialogOpen(selectionData) {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.form.freightInfoList = selectionData;
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            const {
              status,
              message,
            } = await addOilPriceLinkage(this.form);
            this.submitLoading = false;
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.$emit('clearCheckTableData');
            this.dialogClose();
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped>
  .settlement-form {
    width: 80%;
    margin: 0 auto;
  }
</style>
